module.exports = __webpack_public_path__ + "static/varu_3-a2ce3baa871ab4914247d6903a5334c0.jpg";